import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useSettingsStore } from '@/stores/settings'
import { translations, type TranslationKey, type Language } from './translations'

export function useI18n() {
  const settingsStore = useSettingsStore()
  const { language } = storeToRefs(settingsStore)
  
  // Create a function that always reads the latest language value
  function t(key: TranslationKey): string {
    const lang = language.value as Language
    return translations[lang]?.[key] || translations.en[key] || key
  }
  
  return {
    t,
    language,
    // Also expose current language for debugging
    getCurrentLanguage: () => language.value
  }
}
